import React from 'react';
import { StaticQuery, graphql } from 'gatsby';

const IconSvg = props => (
    <StaticQuery
      query={graphql`
        query {
            images: allFile(filter: { sourceInstanceName: { eq: "images" } }) {
                edges {
                    node {
                        relativePath,
                        name,
                        publicURL
                    }
                }
            }
        }
    `}
      render={data => {
            const image = data.images.edges.find(n => {
            return n.node.relativePath.includes(props.iconPath);
        });
        if (!image) {
          return null;
        }
  
        return <img key={image.node.name} src={image.node.publicURL} loading="lazy" alt={props.alt} />
      }}
    />
  );
  
export default IconSvg;
